<tr [ngClass]="{'option_row--set': !!itemTree.examType}">
  <td easEditorBookingItemInheritableTypeHeader [inheritableType]="!itemTree.examType ? 'empty' : 'set'" i18n>
    Exam type
  </td>
  <td>
    @if (!itemTree.examType) {
      <span class="text-muted" i18n>
      Not set
    </span>
    }
    @if (itemTree.examType) {
      <span>
        {{ examTypeName }}
      </span>
    }
    <button mat-icon-button
      aria-label="Edit exam type"
      i18n-aria-label
      (click)="onEdit()">
      <mat-icon>edit</mat-icon>
    </button>
  </td>
  <td>
    @if (!!itemTree.examType) {
      <eas-editor-booking-item-inheritable-type-badge [inheritableType]="'set'">
      </eas-editor-booking-item-inheritable-type-badge>
    }
  </td>
</tr>
